import Button from 'antd/lib/button';
import Tooltip from 'antd/lib/tooltip';
import saveAs from 'file-saver';
import Papa from 'papaparse';
import { useImportContext } from './ImportProvider';
import { BaseButtonProps } from 'antd/lib/button/button';
import { ParsedRecord } from './ImportParser';

type ImportDownloadErrorsButtonProps = BaseButtonProps & {};

export function ImportDownloadErrorsButton({ children, ...buttonProps }: ImportDownloadErrorsButtonProps) {
    const {
        csvConfig,
        viewState: { file, records },
        importErrors,
    } = useImportContext();
    const csvColumns = csvConfig.map(it => it.column);

    const filename = file?.name || 'import';

    return (
        <Tooltip title="Click to download a CSV file with import result">
            <Button
                variant="outlined"
                color="danger"
                onClick={() => downloadImportErrors(filename, records, csvColumns, importErrors)}
                {...buttonProps}
            >
                {children ? children : 'Download Import Errors'}
            </Button>
        </Tooltip>
    );
}

function downloadImportErrors(filename: string, records: ParsedRecord<any>[], csvColumns: string[], importErrors: string[]) {
    const data = [[...csvColumns, 'Errors']];

    for (let row = 0; row < records.length; row++) {
        const rowsWithErrors = Object.values(records[row]).filter(item => item.error);
        const rowErrors = rowsWithErrors.map(item => item.error);
        const rowImportError = importErrors[row];
        if (rowImportError) {
            rowErrors.push(rowImportError);
        }

        data.push([...Object.values(records[row]).map(item => item.value), rowErrors.join(' | ')]);
    }

    const csvData = Papa.unparse(data, {
        quotes: true,
        quoteChar: '"',
        escapeChar: '"',
        delimiter: ',',
        header: true,
        escapeFormulae: true,
    });

    const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8' });
    let importedFileName = filename;
    importedFileName = importedFileName.replace('.csv', '').replace('.CSV', '');
    saveAs(blob, `${importedFileName}-errors.csv`);
}
